import { useEffect, useState } from "react";
import {
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";

import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore";

import { db } from "../firebase";

import "./MarketChart.css";

export default function MarketChart() {
  const { id } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();

  const [match, setMatch] = useState(state?.match || null);
  const [bets, setBets] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);

        let currentMatch = match;

        // Match ikikosekana baada ya reload
        if (!currentMatch && id) {
          const matchSnap = await getDoc(
            doc(db, "matches", id)
          );

          if (matchSnap.exists()) {
            currentMatch = {
              id: matchSnap.id,
              ...matchSnap.data(),
            };

            setMatch(currentMatch);
          }
        }

        // Soma bets za match hii
        const betsQuery = query(
          collection(db, "bets"),
          where("matchId", "==", id)
        );

        const betsSnap = await getDocs(betsQuery);

        const data = betsSnap.docs.map((betDoc) => ({
          id: betDoc.id,
          ...betDoc.data(),
        }));

        setBets(data);
      } catch (error) {
        console.error("Market chart error:", error);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [id]);

  // Group bets kwa score
  const market = {};

  bets.forEach((bet) => {
    const score =
      bet.score ||
      bet.selection?.score ||
      "Unknown";

    const amount = Number(
      bet.amount ||
      bet.stake ||
      bet.quantity ||
      0
    );

    if (!market[score]) {
      market[score] = {
        score,
        totalAmount: 0,
        bettors: 0,
      };
    }

    market[score].totalAmount += amount;
    market[score].bettors += 1;
  });

  const marketRows = Object.values(market).sort(
    (a, b) => b.totalAmount - a.totalAmount
  );

  const totalAmount = marketRows.reduce(
    (sum, item) => sum + item.totalAmount,
    0
  );

  const formatMoney = (value) => {
    return new Intl.NumberFormat("en-TZ", {
      style: "currency",
      currency: "TZS",
      maximumFractionDigits: 0,
    }).format(value || 0);
  };

  if (loading) {
    return (
      <div className="market-page">
        Loading market...
      </div>
    );
  }

  return (
    <div className="market-page">

      <div className="market-top">
        <button
          className="market-back"
          onClick={() => navigate(-1)}
        >
          ←
        </button>

        <div>
          <h2>📈 Market Chart</h2>

          {match && (
            <p>
              {match.A} VS {match.B}
            </p>
          )}
        </div>
      </div>

      <div className="market-summary">
        <div>
          <span>Total Bets</span>
          <strong>{bets.length}</strong>
        </div>

        <div>
          <span>Market Volume</span>
          <strong>
            {formatMoney(totalAmount)}
          </strong>
        </div>
      </div>

      {marketRows.length === 0 ? (
        <div className="no-market">
          Hakuna betting data bado.
        </div>
      ) : (
        <div className="market-list">

          {marketRows.map((item) => {
            const percentage =
              totalAmount > 0
                ? (item.totalAmount / totalAmount) * 100
                : 0;

            return (
              <div
                className="market-row"
                key={item.score}
              >
                <div className="market-row-top">
                  <strong>
                    {item.score}
                  </strong>

                  <span>
                    {percentage.toFixed(1)}%
                  </span>
                </div>

                <div className="market-progress">
                  <div
                    className="market-progress-value"
                    style={{
                      width: `${percentage}%`,
                    }}
                  />
                </div>

                <div className="market-details">
                  <span>
                    👥 {item.bettors} bets
                  </span>

                  <strong>
                    {formatMoney(item.totalAmount)}
                  </strong>
                </div>
              </div>
            );
          })}

        </div>
      )}

    </div>
  );
}